import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildEstimatedTradeCostComparisonWidgetConfigSlice } from './configslice';
import { EstimatedTradeCostComparisonState } from './EstimatedTradeCostComparisonState';
import { EstimatedTradeCostComparisonActionPayload } from './actions';
import { buildEstimatedTradeCostComparisonWidgetComponentSlice } from './componentSlice';

const { reducer: configReducer } =
    buildEstimatedTradeCostComparisonWidgetConfigSlice();
const { reducer: componentReducer } =
    buildEstimatedTradeCostComparisonWidgetComponentSlice();

const EstimatedTradeCostComparisonWidgetReducer =
    combineReducers<EstimatedTradeCostComparisonState>({
        component: componentReducer,
        config: configReducer,
    });

export const estimatedTradeCostComparisonWidgetsReducer = createWidgetsReducer<
    EstimatedTradeCostComparisonState,
    EstimatedTradeCostComparisonActionPayload
>(
    WidgetType.EST_TRADE_COST_COMPARISON_WIDGET,
    EstimatedTradeCostComparisonWidgetReducer
);
